import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { SharedIcon } from "./shared-icon";

const Checkbox = React.forwardRef(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root ref={ref} className={className} {...props}>
    <CheckboxPrimitive.Indicator className="shadcn-checkbox-indicator">
      <SharedIcon iconName="#sprite-checkbox-checked" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
